export default {
	BASE_API_ENDPOINT: 'https://api.tanaqul.co/api',
	// BASE_API_ENDPOINT: 'https://tanaqul-dev.tanaqul.org/api',
	APP_ID: 'krShJeOkf1iEXsq3',
	APP_KEY: 'kFtrex03oaL0xp9SCPFLZaBTSI8KPSTO7TI1WySmuLMgexTKKDyd7DiBb2yLSpyj',
	CK_EDITOR_KEY : 'GPL'
};
